module.exports = __webpack_public_path__ + "static/media/goldBgDark.4972c688.png";